export default __webpack_public_path__ + "static/Swiss721BT-Bold-7ee4b2f5e6093fc3c934aaa05593e1a0.woff";